module.exports = __webpack_public_path__ + "img/agmify-logo-login.png";